import { ctaClick, ctaName, ctaOrigin } from 'public/biLogger';
import wixSite from 'wix-site';
import wixLocation from 'wix-location';

$w.onReady(function () {
	//*** BI - Start ***//
	const pageName = wixSite && wixSite.currentPage ? wixSite.currentPage.name : undefined;
	const pageUrl = wixLocation ? wixLocation.url : undefined;

	$w('#ctaFooter').onClick(event => {
		ctaClick({ pageName, pageUrl, action: ctaName.start_now, origin: ctaOrigin.footer, text: event.target.label });
		wixLocation.to('/templates');
	});
	$w('#ctaHeader').onClick(event => {
		ctaClick({ pageName, pageUrl, action: ctaName.start_now, origin: ctaOrigin.top_bar, text: event.target.label });
		wixLocation.to('/templates');
	});
	//*** BI - End ***//

});